
import { defineComponent, PropType } from 'vue'

import { shortenLargeNumber } from '~/utils/string'

import { IssueFilterChoice } from '~/types/issues'

/**
 * Component to add issue filtering based on category for a repo
 */
export default defineComponent({
  name: 'IssueCategorySelector',

  props: {
    activeSidebarItem: {
      type: String,
      default: 'recommended'
    },
    issueCategories: {
      type: Array as PropType<IssueFilterChoice[]>,
      default: () => []
    },
    occurrenceCounts: {
      type: Object as PropType<Record<string, number>>,
      default: () => ({})
    }
  },

  emits: ['update-category'],

  methods: {
    shortenLargeNumber
  }
})
